var map = {
	"./yone0/图片0.png": 4669,
	"./yone0/图片1.png": 4420,
	"./yone0/图片2.png": 7631,
	"./yone0/图片3.png": 4342,
	"./yone0/图片4.png": 4425,
	"./yone0/图片5.png": 6304,
	"./yone0/图片6.png": 4635,
	"./yone0/图片7.png": 9810,
	"./yone0/图片8.png": 661,
	"./yone0/图片9.png": 8396,
	"./yone1/图片0.png": 5828,
	"./yone1/图片1.png": 9069,
	"./yone1/图片2.png": 3654,
	"./yone1/图片3.png": 1103,
	"./yone1/图片4.png": 9424,
	"./yone1/图片5.png": 3625,
	"./yone2/图片0.png": 1999,
	"./yone2/图片1.png": 3910,
	"./yone2/图片2.png": 4589,
	"./yone2/图片3.png": 8436,
	"./yone3/图片0.png": 8870,
	"./yone3/图片1.png": 7615,
	"./yone3/图片2.png": 5156,
	"./yone3/图片3.png": 2637,
	"./yone3/图片4.png": 3490,
	"./yone3/图片5.png": 7147,
	"./yone4/图片50.png": 3526,
	"./yone4/图片51.png": 7327,
	"./yone4/图片52.png": 5700,
	"./yone4/图片53.png": 5293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9460;